// extracted by mini-css-extract-plugin
export var badge = "ProductPopup-module--badge--cUECF";
export var close = "ProductPopup-module--close--1bCHS";
export var fadeIn = "ProductPopup-module--fadeIn--oxKG8";
export var modal = "ProductPopup-module--modal--S-u2I";
export var overlay = "ProductPopup-module--overlay--yPfKd";
export var title = "ProductPopup-module--title--CDuUY";